import { PhysicalThing } from "../../physicalThing";
import { deserializeXY } from "../../serialization";
import type { XY } from "../../xy";
import { ZOrder } from "../../zOrder";

export class FloatingArrow extends PhysicalThing {
	static key = "FloatingArrow";
	constructor(xy: XY) {
		super(xy, false);
	}

	getZOrder(): number {
		return ZOrder.TOP;
	}

	static deserialize(data: any): FloatingArrow {
		const f = new FloatingArrow(deserializeXY(data.xy));
		f.visualId = data.visualId;
		return f;
	}
}
